import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24c13e4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex justify-center text-gray-400"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "text-red-400 mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Отправить список курьеров на подпись",
    loading: _ctx.state.is_loading,
    "confirm-button-text": "Отправить",
    "confirm-disabled": !_ctx.state.is_active || !_ctx.isCouriers,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.sendToContract
  }, {
    default: _withCtx(() => [
      (!_ctx.isCouriers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " У поставщика нет курьеров "))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_table_scroll_wrapper, {
              loading: _ctx.state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.is_loading,
                  columns: _ctx.CarriersSendColumns,
                  rows: _ctx.couriers
                }, {
                  td: _withCtx(({ row, column, key }) => [
                    (column.key === 'index')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.getIndex(key)), 1)
                        ], 64))
                      : (column.key === 'car')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(row.car_model) + ", " + _toDisplayString(row.car_number), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                          ], 64))
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows"])
              ]),
              _: 1
            }, 8, ["loading"]),
            (!_ctx.state.is_active && !_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Договор отсутствует "))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["loading", "confirm-disabled", "onCancel", "onConfirm"]))
}